import { environment } from "./environment";

export class EnvironmentBase {


    constructor(private host: string, private host_cc:string, private production:boolean,private mockService: boolean,private developing: boolean,private dl: number) {
    }


    public get debuglevel(): number { return this.dl; }
    public get loginCert(): string {return this.host_cc + "/login/cert"}
    public get loginClaveGetToken(): string {return this.host + "/clave/token"}
    public get loginClave(): string {return this.host + "/v1/login/clave"}


    public get apiEstadoFisico(): string { return this.host + "/v1/api/maestras/estadosFisicos"; }
    public get apiTiposEnvases(): string { return this.host + "/v1/api/maestras/tiposEnvases"; }
    public get apiContenidoUnidades(): string { return this.host+"/v1/api/maestras/contenidoUnidades"; }
    public get apiTipoTasas(): string { return this.host   + "/v1/api/maestras/tiposTasas"; }
    public get apiSabores(): string { return this.host +"/v1/api/maestras/sabores"; }
    public get apiNuevoSabor(): string { return this.host +"/v1/api/maestras/sabores/nuevo"; }
    public get apiEdadesUnidades(): string { return this.host+"/v1/api/maestras/edadesUnidades"; }
    public get apiGrupoPacientes(): string { return this.host+"/v1/api/solicitudes/gruposPacientes"; }
    public get apiUploadFile(): string { return this.host +"/v1/upload"; }
    public get apiTipoProductos(): string { return this.host +"/v1/productos/tiposProductos"; }
    public get apiGruposProductos(): string { return this.host +"/v1/productos/gruposProductos"; }
    public get apiTiposIr(): string { return this.host +"/v1/productos/tiposIr"; }
    public get apiMotivosExclusion(): string { return this.host +"/v1/productos/motivosExclusion"; }
    public get apiSubtipoEstados(): string { return this.host +"/v1/productos/subtipoEstados"; }
    public get apiGetProvincias(): string { return this.host +"/v1/api/maestras/provincias"; }

    //APIS OPERADOR ECONOMico
    public get apiEmpresaGetDatos(): string { return this.host + "/v1/empresa/datos"; }
    public get apiEmpresaVersionGetDatos(): string { return this.host + "/v1/empresa/datos/version"; }
    public get apiEmpresaPutDatos(): string { return this.host + "/v1/empresa/datos/put"; }
    public get apiEmpresaSolicitudNueva(): string { return this.host + "/v1/empresa/solicitud/nueva"; }
    public get apiEmpresaSolicitudComprobar(): string { return this.host + "/v1/empresa/solicitud/comprobar"; }
    public get apiEmpresaRegistroSolicitudes(): string { return this.host + "/v1/empresa/solicitud/registro/"; }
    public get apiGetEmpresa(): string { return this.host + "/v1/msc/empresa/datos/"; }
    public get apiConsultaSolicitudes(): string { return this.host + "/v1/empresa/solicitudes"; }
    public get apiPreorderInclusion(): string { return this.host + "/v1/empresa/preorder/"; }
    public get apiPreorderOtros(): string { return this.host + "/v1/upload/preorder/"; }
    public get apiAltaInclusion(): string { return this.host + "/v1/empresa/solicitud/paso/alta"; }
    public get apiExisteProducto(): string { return this.host +"/v1/empresa/productos/existeProducto"; }
    public get apiConsultaSolicitud(): string { return this.host + "/v1/empresa/solicitudes/"; }
    public get apiSolicitudSubsanacion(): string { return this.host + "/v1/empresa/solicitud/paso/subsanacion"; }
    public get apiExisteProductoAlteracion(): string { return this.host + "/v1/empresa/productos/alteracion/existeDesbloqueado"; }
    public get apiPresentacionesAlteracion(): string { return this.host+"/v1/empresa/presentaciones/alteracion/activas/"; }
    public get apiPreviewAlteracion(): string { return this.host+"/v1/empresa/solicitud/paso/altera/preview"; }
    public get apiSolicitudAlteracion(): string { return this.host+"/v1/empresa/solicitud/paso/altera"; }

    //APIS AESAN Y CARTERA
    public get apiDatosEmpresaAESAN(): string { return this.host + "/v1/msc/empresa/datos"; }
    public get apiSolicitudSubsanacionMSC(): string { return this.host + "/v1/msc/solicitudes/subsanar"; }
    public get apiConsultaSolicitudMSC(): string { return this.host + "/v1/msc/solicitudes/"; }
    public get apiConsultaSolicitudesAESAN(): string { return this.host + "/v1/msc/solicitudes/"; }

    public get apiExistePresentacion(): string { return this.host + "/v1/empresa/presentacion/existe"; }
    public get apiGetProductoVersion(): string { return this.host + "/v1/msc/producto"; }
    public get apiProductosResumenMSC(): string { return this.host + "/v1/msc/productos"; }

   //APIS EMPRESA
   public get apiDesistirSolicitud(): string { return this.host + "/v1/empresa/solicitud/desistir"; }
   public get apiPresentarAlegaciones(): string { return this.host + "/v1/empresa/solicitud/alegar"; }
   public get apiProductosResumenEmpresa(): string { return this.host + "/v1/empresa/productos"; }
   public get apiGetProducto(): string { return this.host + "/v1/empresa/productos/codigo"; }

    //APIS COMERCIALIZACION EMPRESA
    public get apiComercializar(): string { return this.host + "/v1/empresa/productos/presentaciones/comercializar"; }
    public get apiProrroga(): string { return this.host + "/v1/empresa/comercializacion/prorroga"; }
    public get apiBaja(): string { return this.host + "/v1/empresa/presentacion/baja"; }
    public get apiSuspension(): string { return this.host + "/v1/empresa/presentacion/suspension_temporal"; }
    public get apiCambioFechaComercializacion(): string { return this.host + "/v1/empresa/presentacion/cambio_fecha_comercializacion"; }
    public get apiDesistirPresentacion(): string { return this.host + "/v1/empresa/presentacion/desistir"; }

    //API COMERCIALIZCIÓN MSC
    public get apiAceptarComercializacion(): string { return this.host + "/v1/msc/productos/presentaciones/aceptarComercializacion"; }
    public get apiSolicitarSubsanacionComercializacion(): string { return this.host + "/v1/msc/comercializacion/subsanacion"; }
    public get apiAnularPresentacion(): string { return this.host + "/v1/msc/comercializacion/anular"; }
    public get apiAceptarProrroga(): string { return this.host + "/v1/msc/comercializacion/aceptarProrroga"; }
    public get apiRechazarProrroga(): string { return this.host + "/v1/msc/comercializacion/rechazarProrroga"; }
    public get apiExcluir(): string { return this.host + "/v1/msc/presentacion/excluir"; }
    public get apiConfirmarBaja(): string { return this.host + "/v1/msc/presentacion/confirmarBaja"; }
    public get apiConfirmarST(): string { return this.host + "/v1/msc/presentacion/confirmarST"; }
    public get apiGetHistorico(): string { return this.host + "/v1/msc/productos/versiones/"; }

    //APIS RESOLUCIONES
    public get apiAceptacionAESAN(): string { return this.host + "/v1/msc/solicitudes/aesan/aceptar"; }
    public get apiDenegacionAESAN(): string { return this.host + "/v1/msc/solicitudes/aesan/rechazar"; }
    public get apiAceptacionCartera(): string { return this.host + "/v1/msc/solicitudes/cartera/aceptar"; }
    public get apiDenegacionCartera(): string { return this.host + "/v1/msc/solicitudes/cartera/rechazar"; }
    public get apiRectificacionCartera(): string { return this.host + "/v1/msc/solicitudes/cartera/rectificar"; }
    public get apiCheckCambioPrecio(): string { return this.host + "/v1/msc/consumo/solicitud/precio/"; }
    public get apiSolicitudRequestGen(): string { return this.host + "/v1/msc/solicitudes/request"; } // api de solicitud genérico
    public get apiPropDefDenegatoriaCartera(): string { return this.host + "/v1/msc/solicitudes/cartera/propuestaDenegatoria"; }
    public get apiPropDefDenegatoriaAESAN(): string { return this.host + "/v1/msc/solicitudes/aesan/propuestaDenegatoria"; }

    //APIS PREVIEWS
    public get apiPreviewAlta(): string { return this.host + "/v1/empresa/solicitud/paso/alta/preview"; }
    public get apiPreviewAceptacionAESAN(): string { return this.host + "/v1/msc/solicitudes/aesan/aceptar/preview"; }
    public get apiPreviewDenegacionAESAN(): string { return this.host + "/v1/msc/solicitudes/aesan/rechazar/preview"; }
    public get apiPreviewAceptacionCartera(): string { return this.host + "/v1/msc/solicitudes/cartera/aceptar/preview"; }
    public get apiPreviewDenegacionCartera(): string { return this.host + "/v1/msc/solicitudes/cartera/rechazar/preview"; }
    public get apiPreviewPropDefDenegatoria(): string { return this.host + "/v1/msc/solicitudes/cartera/propuestaDenegatoria/preview"; }
    public get apiPreviewRectificacionCartera(): string { return this.host + "/v1/msc/solicitudes/cartera/rectificar/preview"; }
    public get apiPreviewGen(): string { return this.host + "/v1/msc/solicitudes/request/preview"; } // api de previsualización genérico
    public get apiPreviewProrroga(): string { return this.host + "/v1/empresa/comercializacion/prorroga/preview"; }

    public get apiPreviewAceptarProrroga(): string { return this.host + "/v1/msc/comercializacion/previewAceptarProrroga"; }
    public get apiPreviewSubsanacionPresentacion(): string { return this.host + "/v1/msc/presentacion/subsanacionPreview"; }
    public get apiPreviewBajaPresentacion(): string { return this.host + "/v1/empresa/presentacion/baja/preview"; }
    public get apiPreviewSuspensionTemporal(): string { return this.host + "/v1/empresa/presentacion/suspension_temporal/preview"; }
    public get apiPreviewConfirmarBaja(): string { return this.host + "/v1/msc/presentacion/confirmarBajaPreview"; }
    public get apiPreviewConfirmarST(): string { return this.host + "/v1/msc/presentacion/confirmarSTPreview"; }


    public get apiDownloadEmpresa(): string { return this.host + "/v1/empresa/documento/"; }
    public get apiDownloadMSC(): string { return this.host + "/v1/msc/documento/"; }

    public get apiParametrizacion(): string { return this.host + "/v1/admin/parameters"; }
    public get apiParametrizacionUpdate(): string { return this.host + "/v1/admin/parameters/update"; }

    //APIS ADMINISTRADOR
    public get apiUsuarios(): string { return this.host + "/v1/admin/usuarios"; }
  public apiUsuario: string = this.host + "/v1/admin/usuarios/";
  public apiUsuariosRoles: string = this.host + "/v1/admin/usuarios/roles/";
  public apiCrearUsuario: string = this.host + "/v1/admin/nuevoUsuario";
  public apiEditarUsuario: string = this.host + "/v1/admin/actualizarUsuario";
  public apiEliminarUsuario: string = this.host + "/v1/admin/eliminarUsuario/";
  public apiActivarUsuario: string = this.host + "/v1/admin/activarUsuario/";
  public apiPerfiles: string = this.host + "/v1/admin/perfiles";
  public apiPerfil: string = this.host + "/v1/admin/perfiles/";
  public apiNombrePerfiles: string = this.host + "/v1/admin/nombrePerfiles";
  public apiCrearPerfil: string = this.host + "/v1/admin/nuevoPerfil";
  public apiEditarPerfil: string = this.host + "/v1/admin/actualizarPerfil";
  public apiEliminarPerfil: string = this.host + "/v1/admin/eliminarPerfil/";
  public apiActivarPerfil: string = this.host + "/v1/admin/activarPerfil/";
  public apiRoles: string = this.host + "/v1/admin/roles";
  public apiNombreEntidades: string = this.host + "/v1/admin/nombreEntidades";
  public apiHealthCheck: string = this.host + "/v1/admin/healthcheckjson";
  public apiHealthCheckService: string = this.host + "/v1/admin/healthcheck";
  public apiAllProductTypes: string = this.host + "/v1/admin/product_types";
  public apiAddProductType: string = this.host + "/v1/admin/product_types/add";
  public apiActivateProductType: string = this.host + "/v1/admin/product_types/activate";
  public apiDeleteProductType: string = this.host + "/v1/admin/product_types/delete";
  public apiAllProductSubTypes: string = this.host + "/v1/admin/product_subtypes";
  public apiAddProductSubType: string = this.host + "/v1/admin/product_subtypes/add";
  public apiUpdateProductSubTypes: string = this.host + "/v1/admin/product_subtypes/update";
  public apiActivateProductSubType: string = this.host + "/v1/admin/product_subtypes/activate";
  public apiDeleteProductSubType: string = this.host + "/v1/admin/product_subtypes/delete";
  public apiFooter: string = this.host + "/v1/admin/footer";
  public apiGetListadoEmpresas: string = this.host + "/v1/msc/empresas";
  public apiGetHistoricoEmpresa: string = this.host + "/v1/msc/empresas/historico/";
  public apiGetListadoEmpresasSolicitudes: string = this.host + "/v1/msc/empresas/solicitudes/";
  public apiGetEmpresaSolicitud: string = this.host + "/v1/msc/empresas/solicitud/";
  public apiGetEmpresaSolicitudRegistro: string = this.host + "/v1/msc/empresas/solicitud/registro/";
  public apiAceptarEmpresaSolicitud: string = this.host + "/v1/msc/empresas/solicitud/aceptar/";
  public apiRechazarEmpresaSolicitud: string = this.host + "/v1/msc/empresas/solicitud/rechazar/";

  //NOMENCLATOR
  public apiNomenclatorGetPublicacionesEntidades: string = this.host + "/v1/entidades/nomenclator/publicaciones";
  public apiNomenclatorGetPublicacionesMSC: string = this.host + "/v1/msc/nomenclator/publicaciones";
  public apiNomenclatorDocumentoEntidades: string = this.host + "/v1/entidades/nomenclator/documento";
  public apiNomenclatorDocumentoMSC: string = this.host + "/v1/msc/nomenclator/documento";
  public apiGetNomenclator: string = this.host + "/v1/msc/nomenclator/datos";
  public apiGenerarNomenclator: string = this.host + "/v1/msc/nomenclator/generacion";
  public apiPublicarNomenclator: string = this.host + "/v1/msc/nomenclator/publicar";
  public apiDownloadNomMsc: string = this.host + "/v1/msc/nomenclator/documento";
  public apiDownloadNomEntidades: string = this.host + "/v1/entidades/nomenclator/documento";

  //CONSUMO
  //Entidades
  public apiGetPlantillaConsumo: string = this.host + "/v1/entidades/consumo/plantilla/";
  public apiCheckCargaConsumo: string = this.host + "/v1/entidades/consumo/existe";
  public apiCargarConsumo: string = this.host + "/v1/entidades/consumo/upload";
  public apiGetConsumoCargasEntidades: string = this.host + "/v1/entidades/consumo/listado";
  public apiGetConsumoDocumentoEntidades: string = this.host + "/v1/entidades/consumo/documento/";
  //Cartera
  public apiGetConsumoCargasMSC: string = this.host + "/v1/msc/consumo/listado";
  public apiGetConsumoDocumentoMSC: string = this.host + "/v1/msc/consumo/documento/";
  public apiAceptarFichaImpactoPreview: string = this.host + "/v1/msc/solicitudes/cartera/impacto/preview";
  public apiGetFichaTecnica: string = this.host + "/v1/msc/documento/ficha/";
  public apiGetInformeConsumo: string = this.host + "/v1/msc/consumo/informe";
  public apiExportarInformeConsumoExcel: string = this.host + "/v1/msc/consumo/informe/excel";
  public apiExportarInformeConsumoPDF: string = this.host + "/v1/msc/consumo/informe/pdf";

  //Firma
  public apiInformes: string = this.host + "/v1/firmas";
  public apiVerPeticion: string = this.host + "/v1/firmas/";
  public apiVerificarPeticion: string = this.host + "/v1/firmas/verificar";
  public apiCancelarPeticion: string = this.host + "/v1/firmas/cancelar";

  //Ir
  public apiUpdateIfSubtypes: string = this.host + "/v1/admin/product_subtypes/updateif";
  public apiGetPresentacionesIr: string = this.host + "/v1/admin/product_subtypes/afectadosIr";
  public apiPostComunicacionIr: string = this.host + "/v1/admin/product_subtypes/comunicacion";

  //MANTENIMIENTO
  public get apiMantenimientoProductos(): string { return this.host + "/v1/mantenimiento/productos"; }
  public get apiMantenimientoProducto(): string { return this.host + "/v1/mantenimiento/producto"; }
  public get apiMantenimientoGuardarProducto(): string { return this.host + "/v1/mantenimiento/modificarProducto"; }
  public get apiMantenimientoHistoricoProducto(): string { return this.host + "/v1/mantenimiento/historico/"; }
  public get apiMantenimientoSubirDocumento(): string { return this.host + "/v1/mantenimiento/subirDocumento"; }
  
  //TRAMITACIONES
  public get apiTramitaciones(): string { return this.host + "/v1/tramitaciones"; }
    
  //ALERTAS
  public apiEnviarAlertaUsuarios: string = this.host + "/v1/alerta";

  //ETIQUETADO
  public apiEtiquetado: string = this.host + "/v1/etiquetado";
  
  //DOCUMENTO
  public apiUpdateDocumento: string = this.host + "/v1/documento/recibido";
  
  //DESARROLLADOR
  public apiDesarrolladorAcceder: string = this.host + "/v1/desarrollador/acceder";
  public apiDesarrolladorQuery: string = this.host + "/v1/desarrollador/query";

  //AUDITORIA
  public apiAuditorias: string = this.host + "/v1/auditorias";
}


/**
 * Creates an environment object based on the provided parameters.
 * @param host - The host URL.
 * @param host_cc - The host CC URL.
 * @param production - Indicates if the environment is for production.
 * @param mockService - Indicates if the environment should use mock services.
 * @param developing - Indicates if the environment is for development.
 * @param debuglevel - The debug level.
 * @returns The created environment object.
 */
export function environmentFactory(host: string, host_cc:string, production:boolean,mockService: boolean,developing: boolean,debuglevel: number) {
  return new EnvironmentBase(host, host_cc,production,mockService,developing,debuglevel);

}




